export default __webpack_public_path__ + "static/media/FPS.fb8c14e4.svg";